/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import CustomLoader from "../../components/loader";
import QueuesListFormComponent from "../../components/FormComponent/QueuesListFormComponent";
import workflow from "../../schema/queueWorkflow";
import {
  addQueue,
  assignOperator,
  QueuePermission,
  radiologyAddForm,
} from "../../schema/addQueue";
import networkList from "../../constants/networkList";
import postService from "../../services/httpService";
import { Modal } from "antd";
import moment from "moment";

const $ = require("jquery");
class Queueadd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      selectedData: {},
      showWorkFlow: true,
      showOperator: false,
      workflowChange: { id: 1 },
      qid: null,
      QueeuErors: {},
      QueueLData: {},
      addQueue: [],
      workflow: [],
      tableSelectValue: [],
      operatorstable: [],
      radiologyAdd: {},
      operatorsTabledisplay: [],
      token_generation_stage_id: "1",
      // assignOperator: [],
      add_queue_payload: {},
      isLoading: false,
    };
  }

  componentDidMount() {
    let addQueueCopy = $.extend(true, {}, addQueue);
    // let assignOperatorCopy = $.extend(true, {}, assignOperator);
    let radiologyAdd = $.extend(true, {}, radiologyAddForm);
    const params = new URLSearchParams(this.props.location.search);
    const qid = params.get("qid");


    this.setState(
      (state) => ({
        qid: qid,
        addQueue: addQueueCopy.feilds,
        // assignOperator,
        // assignOperator: assignOperatorCopy.feilds,
        radiologyAdd: radiologyAdd,
      }),
      () => {
        this.prepareQueue();
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.pathname != this.props.location.pathname) {
      let addQueueCopy = $.extend(true, {}, addQueue);
      let radiologyAdd = $.extend(true, {}, radiologyAddForm);
      const params = new URLSearchParams(this.props.location.search);
      const qid = params.get("qid");
      this.setState(
        (state) => ({
          qid: qid,
          addQueue: addQueueCopy.feilds,
          radiologyAdd: radiologyAdd,
        }),
        () => {
          this.prepareQueue();
        }
      );
    }
  }

  prepareQueue() {
    let { getQueueDetails } = networkList;
    let { addQueue, qid } = this.state;
    // let data = this.state.view;
    let { slug } = this.props.match.params;
    addQueue.map((element, key) => {
      addQueue[key]["value"] = null;
      addQueue[key]["valid"] = false;
      if (element["relationvalue"].length !== 0) {
        addQueue[key]["disable"] = true;
      }
    });
    this.setState((state) => ({ addQueue: addQueue }));
  

    if (qid !== null) {
      try {
        this.setState({ isLoading: true });
        postService(getQueueDetails, "POST", {
          data: { queue_list_id: qid },
        }).then((res) => {
          if (res.status) {
            let data = res.data;
          
            if (res.data) {
              if (slug === "view") {
                addQueue.map((element, key) => {
                  addQueue[key]["errors"] = [];
                  addQueue[key]["readonly"] = true;
                  addQueue[key]["valid"] = true;

                  if (element["name"] === "unit") {
                    addQueue[key]["text"] = data["unit_name"];
                    addQueue[key]["value"] = data["unit_id"];
                  }
                  if (element["name"] === "roomduration") {
                    addQueue[key]["value"] = data["room_duration_percentage"];
                  }
                  if (element["name"] === "qCreateType") {
                    addQueue[key]["text"] = data["queue_type"];
                    addQueue[key]["value"] = data["queue_type"];
                  }
                  if (element["name"] === "roomname") {
                    addQueue[key]["value"] = data["room_number"];
                    addQueue[key]["errors"] = [];
                    addQueue[key]["visiable"] = true;
                    addQueue[key]["disable"] = true;
                  }
                  if (element["name"] === "alloperator") {
                    if (
                      data["service_operators"] &&
                      Array.isArray(data["service_operators"])
                    ) {
                      data["service_operators"].map((service_operator) => {
                        addQueue[key]["text"] =
                          service_operator["service_operator_name"];
                        addQueue[key]["value"] =
                          service_operator["service_operator_id"];
                        addQueue[key]["visiable"] = true;
                      });
                    }
                  }
                  if (element["name"] === "technician") {
                    if (
                      data["technicians"] &&
                      Array.isArray(data["technicians"])
                    ) {
                      data["technicians"].map((technician) => {
                        addQueue[key]["text"] = technician["technician_name"];
                        addQueue[key]["value"] = technician["technician_id"];
                        addQueue[key]["visiable"] = true;
                      });
                    }
                  }
                  if (element["name"] === "work_station") {
                    // if (
                    //   data["workstation"] &&
                    //   Array.isArray(data["workstation"])
                    // ) {
                    //   data["workstation"].map((workstation) => {
                    //     addQueue[key]["text"] =
                    //       workstation["work_station_name"];
                    //     addQueue[key]["value"] =
                    //       workstation["work_station_name"];
                    //     addQueue[key]["visiable"] = true;
                    //   });
                    // }
                    if (data["work_station_name"]) {
                      addQueue[key]["text"] = data["work_station_name"];
                      addQueue[key]["value"] = data["workstation_id"];
                      addQueue[key]["visiable"] = true;
                    }
                  }

                  // assignOperator.map((element, key) => {
                  //   assignOperator[key]["errors"] = [];
                  //   assignOperator[key]["readonly"] = true;
                  //   assignOperator[key]["valid"] = true;
                  // });

                  if (element["name"] === "service_groups") {
                    addQueue[key]["rowfeilds"]["table_body"] = [];
                    let { add_more_feilds } = addQueue[key]["rowfeilds"];
                    data.service_groups &&
                      data.service_groups.map((servicedata, servicedkey) => {
                        let selected_feilds = servicedata;
                        let obj = {
                          id: servicedkey + 1,
                          feilds: [],
                        };
                        let new_add_more_feilds = JSON.parse(
                          JSON.stringify(add_more_feilds)
                        );
                        new_add_more_feilds.map((feild, feild_key) => {
                          if (feild["name"] === "queuedepartment") {
                            new_add_more_feilds[feild_key]["readonly"] = true;
                            new_add_more_feilds[feild_key]["text"] =
                              selected_feilds["department_name"];
                            new_add_more_feilds[feild_key]["value"] =
                              selected_feilds["department_id"];
                          }
                          if (feild["name"] === "service_group") {
                            new_add_more_feilds[feild_key]["readonly"] = true;
                            new_add_more_feilds[feild_key]["text"] =
                              selected_feilds["service_group_name"];
                            obj["service_group"] =
                              selected_feilds["service_group_id"];
                            new_add_more_feilds[feild_key]["value"] =
                              selected_feilds["service_group_id"];
                          }
                          if (feild["name"] === "exclude_services") {
                            new_add_more_feilds[feild_key]["readonly"] = true;
                            let exclued_services_array = [];
                            let exclued_services_name_array = [];
                            if (selected_feilds["exclued_services"]) {
                              selected_feilds["exclued_services"].map(
                                (data) => {
                                  exclued_services_array.push(
                                    data["service_id"]
                                  );
                                  exclued_services_name_array.push(
                                    data["service_name"]
                                  );
                                }
                              );
                            }
                            //
                            new_add_more_feilds[feild_key]["text"] =
                              exclued_services_name_array.toString();
                            new_add_more_feilds[feild_key]["value"] =
                              exclued_services_array;
                          }
                          if (feild["name"] === "action") {
                            new_add_more_feilds[feild_key]["text"] =
                              selected_feilds["action"];
                            new_add_more_feilds[feild_key]["element"] = "text";
                          }
                        });

                        obj["feilds"] = new_add_more_feilds;

                        addQueue[key]["rowfeilds"]["table_body"].push(obj);
                     
                      });
                  }
                  if (element["name"] === "wDays" && element['visiable']) {
                    data["working_days"].map((wdays, wdays_key) => {
                      element["groupData"].map((gdata, gkey) => {
                        addQueue[key]["groupData"][gkey]["readonly"] = true;
                        addQueue[key]["groupData"][gkey]["disable"] = true;
                        addQueue[key]["groupData"][gkey]["valid"] = true;

                        if (wdays["business_day"] === gdata["business_day"]) {
                          if (
                            wdays["business_from_time"] &&
                            wdays["business_to_time"]
                          ) {
                            addQueue[key]["groupData"][gkey]["value"] = true;
                          }
                          gdata["subgroupData"].map((feild, feild_key) => {
                            addQueue[key]["groupData"][gkey]["subgroupData"][
                              feild_key
                            ]["errors"] = [];
                            addQueue[key]["groupData"][gkey]["subgroupData"][
                              feild_key
                            ]["readonly"] = true;
                            addQueue[key]["groupData"][gkey]["subgroupData"][
                              feild_key
                            ]["disable"] = true;
                            addQueue[key]["groupData"][gkey]["subgroupData"][
                              feild_key
                            ]["valid"] = true;

                            if (feild_key === 0) {
                              addQueue[key]["groupData"][gkey]["subgroupData"][
                                feild_key
                              ]["value"] = wdays["business_from_time"]
                                ? wdays["business_from_time"]
                                : "--";
                            }
                            if (feild_key === 1) {
                              addQueue[key]["groupData"][gkey]["subgroupData"][
                                feild_key
                              ]["value"] = wdays["business_to_time"]
                                ? wdays["business_to_time"]
                                : "--";
                            }
                          });
                        }
                      });
                    });
                  }
                  if (element["relationvalue"].length !== 0) {
                    addQueue[key]["disable"] = true;
                  }
                });

                this.setState((state) => ({
                  addQueue: addQueue,
                  // assignOperator: assignOperator,
                  isLoading: false,
                }));
              
              }
              if (slug === "edit") {
                let payload = {};
                payload["queue_list_id"] = qid;
                addQueue.map((element, key) => {
                  addQueue[key]["errors"] = [];
                

                  if (element["name"] === "unit") {
                    addQueue[key]["text"] = data["unit_name"];
                    addQueue[key]["value"] = data["unit_id"];
                    // let payload = {};
                    payload["unit_id"] = data["unit_id"];
                    this.setState((state) => ({ add_queue_payload: payload }));
                  }
                  if (element["name"] === "roomduration") {
                    addQueue[key]["value"] = data["room_duration_percentage"];
                    payload["room_duration_percentage"] =
                      data["room_duration_percentage"];

                    this.setState((state) => ({ add_queue_payload: payload }));
                  }
                  if (element["name"] === "qCreateType") {
                    addQueue[key]["text"] = data["queue_type"];
                    addQueue[key]["value"] = data["queue_type"];
                    payload["queue_type"] = data["queue_type"];

                  
                    this.setState((state) => ({ add_queue_payload: payload }));
                  }
                  if (element["name"] === "roomname") {
                    addQueue[key]["value"] = data["room_number"];
                    addQueue[key]["is_remote_valid"] = data["room_number"]
                      ? true
                      : false;
                    addQueue[key]["visiable"] = true;
                  }
                  if (element["name"] === "alloperator") {
                    if (
                      data["service_operators"] &&
                      Array.isArray(data["service_operators"])
                    ) {
                      data["service_operators"].map((service_operator) => {
                        addQueue[key]["text"] =
                          service_operator["service_operator_name"];
                        addQueue[key]["value"] =
                          service_operator["service_operator_id"];
                        addQueue[key]["visiable"] = true
                      });
                    }
                  }
                  if (element["name"] === "technician") {
                    if (
                      data["technicians"] &&
                      Array.isArray(data["technicians"])
                    ) {
                      data["technicians"].map((technician) => {
                        addQueue[key]["text"] = technician["technician_name"];
                        addQueue[key]["value"] = technician["technician_id"];
                        addQueue[key]["visiable"] = true
                      });
                    }
                  }
                  if (element["name"] === "work_station") {
                    // if (
                    //   data["workstation"] &&
                    //   Array.isArray(data["workstation"])
                    // ) {
                    //   data["workstation"].map((workstation) => {
                    //     addQueue[key]["text"] =
                    //       workstation["work_station_name"];
                    //     addQueue[key]["value"] =
                    //       workstation["work_station_name"];
                    //   });
                    // }

                    if (data["work_station_name"]) {
                      addQueue[key]["text"] = data["work_station_name"];
                      addQueue[key]["value"] = data["workstation_id"];
                      addQueue[key]["visiable"] = true;
                    }
                  }
                  if (element["name"] === "service_groups") {
                    addQueue[key]["rowfeilds"]["table_body"] = [];
                    let { add_more_feilds } = addQueue[key]["rowfeilds"];
                    data.service_groups &&
                      data.service_groups.map((servicedata, servicedkey) => {
                        let selected_feilds = servicedata;
                        let obj = {
                          id: servicedkey + 1,
                          feilds: [],
                        };
                        let new_add_more_feilds = JSON.parse(
                          JSON.stringify(add_more_feilds)
                        );
                        new_add_more_feilds.map((feild, feild_key) => {
                          if (feild["name"] === "queuedepartment") {
                            new_add_more_feilds[feild_key]["readonly"] = true;
                            new_add_more_feilds[feild_key]["text"] =
                              selected_feilds["department_name"];
                            new_add_more_feilds[feild_key]["value"] =
                              selected_feilds["department_id"];
                          }
                          if (feild["name"] === "service_group") {
                            new_add_more_feilds[feild_key]["readonly"] = true;
                            new_add_more_feilds[feild_key]["text"] =
                              selected_feilds["service_group_name"];
                            obj["service_group"] =
                              selected_feilds["service_group_id"];
                            new_add_more_feilds[feild_key]["value"] =
                              selected_feilds["service_group_id"];
                          }
                          if (feild["name"] === "exclude_services") {
                            new_add_more_feilds[feild_key]["readonly"] = true;
                            let exclued_services_array = [];
                            let exclued_services_name_array = [];
                            if (selected_feilds["exclued_services"]) {
                              selected_feilds["exclued_services"].map(
                                (data) => {
                                  exclued_services_array.push(
                                    data["service_id"]
                                  );
                                  exclued_services_name_array.push(
                                    data["service_name"]
                                  );
                                }
                              );
                            }
                            //
                            new_add_more_feilds[feild_key]["text"] =
                              exclued_services_name_array.toString();
                            new_add_more_feilds[feild_key]["value"] =
                              exclued_services_array;
                          }
                          if (feild["name"] === "action") {
                            new_add_more_feilds[feild_key]["text"] =
                              selected_feilds["action"];
                            new_add_more_feilds[feild_key]["element"] = "action";
                          }
                        });

                        obj["feilds"] = new_add_more_feilds;

                        addQueue[key]["rowfeilds"]["table_body"].push(obj);
                     
                      });
                    // if (data["service_groups"]) {
                    //   data["service_groups"].map(sgdata, => {
                    // //     payload["service_groups"] = data["unit_id"];
                    // // this.setState((state) => ({ add_queue_payload: payload }));
                    
                    //     tableFields.map((feild, feildkey) => {
                    //       if(feildkey===0){
                    //         if(feild.name === "queuedepartment"){
                    //           tableFields[feildkey]["value"] = sgdata["department_id"]
                    //           tableFields[feildkey]["text"] = sgdata["department_name"]
                    //         }
                    //         if(feild.name === "service_group"){
                    //           tableFields[feildkey]["value"] = sgdata["service_group_id"]
                    //           tableFields[feildkey]["text"] = sgdata["service_group_name"]
                    //         }
                    //       }else{
                    //         let last_element = addQueue[key]["rowfeilds"]["table_body"][addQueue[key]["rowfeilds"]["table_body"].length - 1];
                    //         let last_id;
                    //         if (last_element === undefined) {
                    //             last_id = feildkey;
                    //         }
                    //         let obj = {
                    //           "feilds": (addQueue[key]["rowfeilds"] && addQueue[key]["rowfeilds"]['add_more_feilds']) ? JSON.parse(JSON.stringify(addQueue[key]["rowfeilds"]['add_more_feilds'])) : [],
                    //           id: last_id,
                    //           input_feild: [],
                    //           text: "Highend",
                    //           'key_word': 'add_more',
                    //           type: "text"
                    //       }
                    //       }
                         
                    //       // if(feild.name === "exclude_services"){
                    //       //   let ids = [], names = [];
                    //       //   sgdata["exclued_services"].map(exsdata => {
                    //       //     ids.push(exsdata.service_id)
                    //       //     names.push(exsdata.service_name)
                    //       //   })
                    //       //   tableFields[feildkey]["value"] = ids
                    //       //   tableFields[feildkey]["text"] = names
                    //       // }
                    //     })
                    //   })
                    // }
                  }
                  if (element["name"] === "wDays") {
                    data["working_days"] && data["working_days"].map((wdays, wdays_key) => {
                   
                      element["groupData"].map((gdata, gkey) => {
                     

                        // addQueue[key]["groupData"][gkey]["readonly"] = true;
                        // addQueue[key]["groupData"][gkey]["disable"] = false;
                        // addQueue[key]["groupData"][gkey]["valid"] = true;

                        if (wdays["business_day"] === gdata["business_day"]) {
                          if (
                            wdays["business_from_time"] &&
                            wdays["business_to_time"]
                          ) {
                            addQueue[key]["groupData"][gkey]["value"] = true;
                          }

                          gdata["subgroupData"].map((feild, feild_key) => {
                            addQueue[key]["groupData"][gkey]["subgroupData"][
                              feild_key
                            ]["errors"] = [];

                            addQueue[key]["groupData"][gkey]["subgroupData"][
                              feild_key
                            ]["disable"] = false;
                            addQueue[key]["groupData"][gkey]["subgroupData"][
                              feild_key
                            ]["valid"] = true;
                            addQueue[key]["groupData"][gkey]["subgroupData"][
                              feild_key
                            ]["readonly"] = true;


                            if (feild_key === 0) {
                              addQueue[key]["groupData"][gkey]["subgroupData"][
                                feild_key
                              ]["value"] = wdays["business_from_time"]
                                ? wdays["business_from_time"]
                                : "--";
                            }
                            if (feild_key === 1) {
                              addQueue[key]["groupData"][gkey]["subgroupData"][
                                feild_key
                              ]["value"] = wdays["business_to_time"]
                                ? wdays["business_to_time"]
                                : "--";
                            }
                          });
                        }
                      });
                    });
                  
                  }
                  if (element["relationvalue"].length !== 0) {
                    addQueue[key]["disable"] = true;
                  }
                });

                // assignOperator.map((element, key) => {});
                this.setState((state) => ({
                  addQueue: addQueue,
                  // assignOperator: assignOperator,
                  isLoading: false,
                }));
             
              }
            }
          } else {
            Modal.error({
              title: "Error Message",
              content: "Oops! Something is wrong. Please try again.",
            });
            this.setState({ isLoading: false });
          }
        });
      } catch (error) {
   
        this.setState((state) => ({ isLoading: false }));
        Modal.error({
          title: "Error Message",
          content: "Oops, Something is wrong. Please try again.",
        });
      }
    }
  }

  queueChange(event) {

    QueuePermission.filter((element) => {
      if (element["id"] === event) {
        this.setState((state) => ({ workflowChange: element }));
      }
    });
  }

  onChange(event) {
    console.clear();
  

    let { addQueue, assignOperator } = this.state;
    // addQueue.map((data, key) => {
    //   console.log("data addQueue", data);

    //   // if (event.id === "room") {
    //   //   if (data.name === "roomname") {
    //   //     addQueue[key]["value"] = null;
    //   //     addQueue[key]["is_remote_valid"] = false;
    //   //     addQueue[key]["errors"] = [];
    //   //     addQueue[key]["visiable"] = true;
    //   //   }
    //   // if (data.name === "doctorname") {
    //   //   addQueue[key]["value"] = null;
    //   //   addQueue[key]["text"] = null;
    //   //   addQueue[key]["is_remote_valid"] = false;
    //   //   addQueue[key]["errors"] = [];
    //   //   addQueue[key]["visiable"] = false;
    //   // }
    //   // }
    //   // if (event.id === "doctor") {
    //   //   if (data.name === "doctorname") {
    //   //     addQueue[key]["value"] = null;
    //   //     addQueue[key]["text"] = null;
    //   //     addQueue[key]["is_remote_valid"] = false;
    //   //     addQueue[key]["errors"] = [];
    //   //     addQueue[key]["visiable"] = true;
    //   //   }
    //   //   if (data.name === "roomname") {
    //   //     addQueue[key]["value"] = null;
    //   //     addQueue[key]["is_remote_valid"] = false;
    //   //     addQueue[key]["errors"] = [];
    //   //     addQueue[key]["visiable"] = false;
    //   //   }
    //   // }

    //   if (data.name === event.name) {
    //     if (data.is_remote_validation) {
    //       this.validateFeilds(data, event, addQueue, "addQueue");
    //     }
    //   }
    // });

    this.setState({ addQueue: addQueue });
    addQueue.filter((element, key) => {
      if (element["name"] === event.parrentName) {
      
        // if (event.parrentName === 'department') {
        //     this.setState((state) => ({ showOperator: true }));
        // }
        if (event.parrentName === "unit") {
          workflow.feilds.map((data, key) => {
            workflow.feilds[key]["value"] = false;
            workflow.feilds[key]["valid"] = false;
          });
        }
        if (event.parrentName === "qCreateType") {
          if (event.value === "billing") {
            addQueue.map((type) => {
              if (type.name === "work_station") {
                type.visiable = true;
              }
              if (type.name === "alloperator") {
                type.visiable = false;
              }
              if (type.name === "technician") {
                type.visiable = false;
              }
            });
          } else if (event.value === "radiology") {
            addQueue.map((type) => {
              if (type.name === "alloperator") {
                type.visiable = true;
              }
              if (type.name === "technician") {
                type.visiable = true;
              }
              if (type.name === "work_station") {
                type.visiable = true;
              }
            });
          } else {
            addQueue.map((type) => {
              if (type.name === "alloperator") {
                type.visiable = true;
              }
              if (type.name === "work_station") {
                type.visiable = true;
              }
              if (type.name === "technician") {
                type.visiable = false;
              }
            });
          }
        }
        if (event.parrentMode === "single") {
          addQueue[key]["value"] = event.value;
          addQueue[key]["valid"] = true;
          addQueue.slice(key + 1).map((sele, skey) => {
            if (sele["relation"] && sele["relationvalue"] !== 0) {
              if (event.id === "service" && event.id === element["name"]) {
                addQueue[key + 1 + skey]["value"] = event.serviceTime;
                addQueue[key + 1 + skey]["valid"] = true;
                addQueue[key + 1 + skey]["disable"] = true;
              } else {
                addQueue[key + 1 + skey]["value"] = null;
                addQueue[key + 1 + skey]["valid"] = false;
                addQueue[key + 1 + skey]["disable"] = true;
              }
            }
          });
        }
        if (event.parrentMode === "group") {
          if (event.parrentName === "qCreateType") {
         
            addQueue[key]["value"] = event.value;
          }
          element["groupData"].filter((gele, gkey) => {
            if (gele["name"] === event.id) {
            
              addQueue[key]["groupData"][gkey]["value"] = event.value;
              addQueue[key]["groupData"][gkey]["valid"] = true;
            }
            if (gele["subgroupData"]) {
              gele["subgroupData"].filter((gelee, ggkey) => {
                if (gele["name"] === event.id) {
               
                  addQueue[key]["groupData"][gkey]["subgroupData"][ggkey][
                    "disable"
                  ] = event.value ? false : true;
                  addQueue[key]["groupData"][gkey]["subgroupData"][ggkey][
                    "valid"
                  ] = event.value ? true : false;
                }
                if (gele["name"] === event.id && event.value === false) {
               
                  addQueue[key]["groupData"][gkey]["subgroupData"][ggkey][
                    "value"
                  ] = "null";
                  addQueue[key]["groupData"][gkey]["subgroupData"][ggkey][
                    "text"
                  ] = "null";
                }
                if (gelee["name"] === event.id) {
                  addQueue[key]["groupData"][gkey]["subgroupData"][ggkey][
                    "value"
                  ] = event.value;
                }
              });
            }
          });
        }
      }
      if (element["relation"] && element["relationvalue"] !== 0) {
        let rdvalid = [];
        element["relationvalue"].map((rv, rk) => {
          addQueue.filter((relement, rkey) => {
            if (relement["name"] === rv) {
              rdvalid.push(relement["value"] != null);
            }
          });
        });
        if (rdvalid.includes(false)) {
          addQueue[key]["value"] = null;
          addQueue[key]["valid"] = false;
          addQueue[key]["disable"] = true;
        } else {
          addQueue[key]["disable"] = false;
        }
      }
    });

    if (event.name === "unit") {
      let payload = {};
      payload["unit_id"] = event["value"];
      this.setState((state) => ({ add_queue_payload: payload }));
    }
    // assignOperator.filter((element, key) => {
    //   if (element["name"] === event.parrentName) {
    //     if (event.parrentMode === "single") {
    //       assignOperator[key]["value"] = event.value;
    //       assignOperator[key]["valid"] = true;
    //       assignOperator.slice(key + 1).map((sele, skey) => {
    //         if (sele["relation"] && sele["relationvalue"] !== 0) {
    //           if (event.id === "service" && event.id === element["name"]) {
    //             assignOperator[key + 1 + skey]["value"] = event.serviceTime;
    //             assignOperator[key + 1 + skey]["valid"] = true;
    //             assignOperator[key + 1 + skey]["disable"] = true;
    //           } else {
    //             assignOperator[key + 1 + skey]["value"] = null;
    //             assignOperator[key + 1 + skey]["valid"] = false;
    //             assignOperator[key + 1 + skey]["disable"] = true;
    //           }
    //         }
    //       });
    //     }
    //     if (event.parrentMode === "group") {
    //       assignOperator[key]["value"] = event.value;
    //       element["groupData"].filter((gele, gkey) => {
    //         if (gele["name"] === event.id) {
    //           console.log("came");
    //           assignOperator[key]["groupData"][gkey]["value"] = event.value;
    //           assignOperator[key]["groupData"][gkey]["valid"] = true;
    //         }
    //       });
    //     }
    //   }

    //   if (element["relation"] && element["relationvalue"] !== 0) {
    //     let rdvalid = [];
    //     element["relationvalue"].map((rv, rk) => {
    //       assignOperator.filter((relement, rkey) => {
    //         if (relement["name"] === rv) {
    //           rdvalid.push(relement["value"] != null);
    //         }
    //       });
    //     });
    //     if (rdvalid.includes(false)) {
    //       assignOperator[key]["value"] = null;
    //       assignOperator[key]["valid"] = false;
    //       assignOperator[key]["disable"] = true;
    //     } else {
    //       assignOperator[key]["disable"] = false;
    //     }
    //   }
    // });
  }

  validateFeilds(data, event, feilds, stata_key) {
    let { add_queue_payload } = this.state;
    let payload = {
      search_key: event.value,
      unitid: add_queue_payload["unit_id"]
        ? add_queue_payload["unit_id"]
        : null,
    };

    if (event.name === "roomname") {
      payload["roomname"] = event.text;
    }
    // if (event.name === "doctorname") {
    //   payload["queue_type"] = "doctor";
    // }
    if (event.name === "qCreateType") {
      payload["queue_type"] = event.text;
    }

    postService("checkQueueDuplicate", "POST", payload).then((res) => {
      console.info("Work Flow", res);
      feilds.map((data, key) => {
        if (data.name === event.name) {
          if (res.status) {
            feilds[key]["value"] = event.value;
            feilds[key]["is_remote_valid"] = true;
            feilds[key]["errors"] = [];
          } else {
            feilds[key]["value"] = event.value;
            feilds[key]["is_remote_valid"] = false;
            feilds[key]["errors"] = [{ message: res.message }];
          }
        }
      });
      this.setState({ addQueue: feilds });
    });
  }

  inputChangedState(event) {
    console.log(event);
  }
  redirect() {
    this.props.history.push("/queue/queue-list");
  }
  opertBelete(id) {
   

    this.state.operatorsTabledisplay.map((data, key) => {
      if (data["id"] === id) {
      
        this.state.operatorsTabledisplay.splice(key, 1);
      }
    });

    this.state.operatorstable.map((data, key) => {
      if (data["id"] === id) {
     
        this.state.operatorstable.splice(key, 1);
      }
    });

    this.setState((state) => ({ date: new Date() }));
  }

  flowChange(evt) {
    this.setState((state) => ({ workflow: evt }));
  }

  selectChanges(evt) {
    console.log(evt);
  }

  fetchProcessflow() {
    const { queue_workflow } = networkList;
    postService(queue_workflow, "GET", "null").then((res) => {
      console.info("Work Flow", res);
      let { data } = res;
      workflow.feilds.map((wdata, wkey) => {
        data.find((element) => {
          if (element["id"] === wdata["id"]) {
            workflow.feilds[wkey]["label"] = element["process_type"];
            workflow.feilds[wkey]["status"] = element["status"];
          }
        });
      });
  
    });
  }

  stage_id(value) {
    this.setState((state) => ({ token_generation_stage_id: value }));
  }
  // next = (current) => {
  //   this.setState({ current });
  // };

  // prev = (current) => {
  //   this.setState({ current });
  // };

  onSubmit = () => {
    let { addQueue } = this.state;
    let { assignOperator, add_queue_payload } = this.state;
    let payload = {};
    let errors = [];
    // tab1sumbit
    if (addQueue) {
   
      // let payload = {};
      // let errors = [];
      payload["exclued_services"] = [];
      addQueue.map((data, key) => {
        addQueue[key]["errors"] = [];
        if (data["mode"] === "single") {
          if (data["value"] && data["visiable"]) {
            switch (data["name"]) {
              case "roomname":
                // if (data.is_remote_validation && data.is_remote_valid) {
                //   payload["room_number"] = data["value"];
                // } else {
                //   payload["room_number"] = null;
                //   addQueue[key]["errors"].push({
                //     message: `Please ${data["placeholder"]}`,
                //   });
                //   errors.push(false);
                // }
                payload["room_number"] = data["value"];
                break;
              case "roomduration":
                payload["room_duration"] = data["value"];
                break;
              case "unit":
                payload["unit_id"] = data["value"];
                break;
              case "qCreateType":
                payload["queue_type"] = data["text"];
                break;
              default:
                break;
            }
          } else {
            if (data["visiable"]) {
              addQueue[key]["errors"].push({
                message: `Please ${data["placeholder"]}`,
              });
              errors.push(false);
            }
          }
        }
        if (data["mode"] === "group") {
          // if (data["name"] === "qCreateType") {
          //   payload["queue_type"] = data.value;

          //   if (data.value) {
          //     addQueue[key]["errors"] = [];
          //     errors.push(true);
          //   } else {
          //     addQueue[key]["errors"].push({
          //       message: `Please ${data["placeholder"]}`,
          //     });
          //     errors.push(false);
          //   }
          // }
          if (data["name"] === "wDays") {
            let bhdays = [];
            data["groupData"].map((gdata, gkey) => {
              let obj = {};
              obj["business_day"] = gdata["business_day"];
              obj[gdata["business_day"]] = gdata["value"] ? true : false;
              let from_time = null;
              let to_time = null;
              gdata["subgroupData"].map((feild, feild_key) => {
                addQueue[key]["groupData"][gkey]["subgroupData"][feild_key][
                  "errors"
                ] = [];

                if (feild_key === 0) {
                  from_time = feild.value;
                  obj["business_hours_from"] = feild.value;
                }
                if (feild_key === 1) {
                  to_time = feild.value;
                  obj["business_hours_to"] = feild.value;
                }

                if (gdata["value"]) {
                  if (feild.value) {
                    if (to_time) {
                      if (
                        moment(`2/2/1990 ${to_time}`).isAfter(
                          moment(`2/2/1990 ${from_time}`)
                        )
                      ) {
                        errors.push(true);
                      }
                      if (
                        moment(`2/2/1990 ${to_time}`).isSameOrBefore(
                          moment(`2/2/1990 ${from_time}`)
                        )
                      ) {
                        errors.push(false);
                        addQueue[key]["groupData"][gkey]["subgroupData"][
                          feild_key
                        ]["errors"] = [
                          { message: `To time cannot be less than From time` },
                        ];
                      }
                    }
                    if (from_time) {
                      errors.push(true);
                    }
                  } else {
                    addQueue[key]["groupData"][gkey]["subgroupData"][feild_key][
                      "errors"
                    ] = [
                      {
                        message: `Please Select ${
                          feild_key ? "To Time" : "From Time"
                        }`,
                      },
                    ];
                    errors.push(false);
                  }
                }
              });
              if (gdata["value"] == true) {
                bhdays.push(obj);
              }
            });
            payload["working_days"] = bhdays;
            // if (bhdays && Array.isArray(bhdays) && bhdays.length == 0) {
            //   addQueue[key]["errors"].push({
            //     message: `Please Select Working Days`,
            //   });
            //   errors.push(false);
            // }
          }
        }
        if (data["mode"] === "table") {
          let series_group = [];
          if (data["rowfeilds"]) {
            data["rowfeilds"]["table_body"].map((body, body_key) => {
              let obj = {};
              body["feilds"].map((feild, feild_key) => {
                addQueue[key]["rowfeilds"]["table_body"][body_key]["feilds"][
                  feild_key
                ]["errors"] = [];
                if (
                  feild.visible &&
                  feild.element !== "text" &&
                  feild.element !== "action"
                ) {
                  if (feild.name === "queuedepartment") {
                    obj["department_id"] = feild.value;
                  }
                  if (feild.name === "service_group") {
                    obj["service_group_id"] = feild.value;
                  }
                  if (feild.name === "exclude_services") {
                    obj["exclued_services"] = feild.value;
                    payload["exclued_services"] = payload[
                      "exclued_services"
                    ].concat(feild.value ? feild.value : []);
                  }

                  if (feild.value) {
                    errors.push(true);
                  } else {
                    if (feild.name !== "exclude_services") {
                      errors.push(false);
                      let name = {};
                      name[feild.name] = false;
                      errors.push(name);
                      addQueue[key]["rowfeilds"]["table_body"][body_key][
                        "feilds"
                      ][feild_key]["errors"] = [
                        {
                          message: `Please ${feild["placeholder"]} ${feild["title"]}`,
                        },
                      ];
                    }
                  }
                }
              });
              if (Object.keys(obj).length !== 0) {
                series_group.push(obj);
              }
            });
          }
          payload[data["name"]] = series_group;
        }
      });

      addQueue.map((data, key) => {
        // addQueue[key]["errors"] = [];
        if (data["mode"] === "single") {
          switch (data["name"]) {
            case "alloperator":
              payload["service_operator_id"] = data["value"];
              break;
            case "technician":
              payload["technician_id"] = data["value"];
              break;
            case "work_station":
              payload["workstation_id"] = data["value"];
              break;
            default:
              break;
          }
          // if (data["value"]) {
          //   errors.push(true);
          // } else if (data.name !== "technician") {
          //   addQueue[key]["errors"].push({
          //     message: `Please ${data["placeholder"]}`,
          //   });
          //   errors.push(false);
          // }
          // if (data["value"]) {
          //   errors.push(true);
          // } else {
          //   errors.push(false);
          // }
        }
      });

      console.clear();
    
      this.setState((state) => ({
        addQueue: addQueue,
        // add_queue_payload: payload,
      }));

      //   validations check;
      if (!errors.includes(false)) {
        this.setState({ isLoading: true });
        let This = this;
        try {
          postService("createQueueConfig", "POST", { data: payload }).then(
            (res) => {
              console.info("Work Flow", res);
              if (res.status) {
                this.setState({ isLoading: false });
                Modal.success({
                  title: "Success",
                  content: `${res.message}`,
                  onOk: () => {
                    this.props.history.push("/queue/queue-list");
                  },
                });
              } else {
                this.setState({ isLoading: false });
                Modal.error({
                  title: "Error",
                  content: `${res.message}`,
                });
              }
            }
          );
        } catch (error) {
          console.log(error);
          this.setState((state) => ({ isLoading: false }));
          Modal.error({
            title: "Error Message",
            content: "Something is wrong. Please try again.",
          });
        }
      }
    }

    // tab2submit
    // if (assignOperator) {
    //   console.log("assignOperator:", assignOperator);
    //   // let payload = {};
    //   // let errors = [];
    //   // assignOperator.map((data, key) => {
    //   //   assignOperator[key]["errors"] = [];
    //   //   if (data["mode"] === "single") {
    //   //     switch (data["name"]) {
    //   //       case "alloperator":
    //   //         payload["service_operator_id"] = data["value"];
    //   //         break;
    //   //       case "technician":
    //   //         payload["technician_id"] = data["value"];
    //   //         break;
    //   //       case "workstation":
    //   //         payload["workstation_id"] = data["value"];
    //   //         break;
    //   //       default:
    //   //         break;
    //   //     }
    //   //     // if (data["value"]) {
    //   //     //   errors.push(true);
    //   //     // } else if (data.name !== "technician") {
    //   //     //   assignOperator[key]["errors"].push({
    //   //     //     message: `Please ${data["placeholder"]}`,
    //   //     //   });
    //   //     //   errors.push(false);
    //   //     // }
    //   //     // if (data["value"]) {
    //   //     //   errors.push(true);
    //   //     // } else {
    //   //     //   errors.push(false);
    //   //     // }
    //   //   }
    //   // });
    //   payload = Object.assign({}, add_queue_payload, payload);

    //   this.setState((state) => ({ assignOperator: assignOperator }));

    //   //   validations check;
    //   if (!errors.includes(false)) {
    //     this.setState({ isLoading: true });
    //     let This = this;
    //     try {
    //       console.log("payload", payload);
    //       postService("createQueueConfig", "POST", { data: payload }).then(
    //         (res) => {
    //           console.info("Work Flow", res);
    //           if (res.status) {
    //             this.setState({ isLoading: false });
    //             Modal.success({
    //               title: "Success",
    //               content: `${res.message}`,
    //               onOk: () => {
    //                 this.props.history.push("/queue/queue-list");
    //               },
    //             });
    //           } else {
    //             this.setState({ isLoading: false });
    //             Modal.error({
    //               title: "Error",
    //               content: `${res.message}`,
    //             });
    //           }
    //         }
    //       );
    //     } catch (error) {
    //       console.log(error);
    //       this.setState((state) => ({ isLoading: false }));
    //       Modal.error({
    //         title: "Error Message",
    //         content: "Something is wrong. Please try again.",
    //       });
    //     }
    //   }
    // }
  };
  // tab1sumbit = () => {};
  // tab2submit = () => {};

  onUpdate = () => {
    let { addQueue } = this.state;
    let { assignOperator } = this.state;
    // tab1update
    if (addQueue) {
      console.clear();
   

      let payload = {};
      let errors = [];

      payload["exclued_services"] = [];
      if (addQueue[3].value) {
        payload["room_duration_percentage"] = addQueue[3].value;
      } else {
        payload["room_duration_percentage"] = 0;
      }
      addQueue.map((data, key) => {
        addQueue[key]["errors"] = [];
        if (data["mode"] === "single") {
          if (data["value"] && data["visiable"]) {
            switch (data["name"]) {
              case "roomname":
                // if (data.is_remote_validation && data.is_remote_valid) {
                //   payload["room_number"] = data["value"];
                // } else {
                //   payload["room_number"] = null;
                //   addQueue[key]["errors"].push({
                //     message: `Please ${data["placeholder"]}`,
                //   });
                //   errors.push(false);
                // }
                payload["room_number"] = data["value"];
                break;
              case "roomduration":
                payload["room_duration"] = data["value"];
                break;
              case "unit":
                payload["unit_id"] = data["value"];
                break;
              case "qCreateType":
                payload["queue_type"] = data["text"];
                break;

              default:
                break;
            }
          } else {
            if (data["visiable"]) {
              addQueue[key]["errors"].push({
                message: `Please ${data["placeholder"]}`,
              });
              errors.push(false);
            }
          }
        }
        if (data["mode"] === "group") {
          if (data["name"] === "wDays") {
            let bhdays = [];

            data["groupData"].map((gdata, gkey) => {
              let obj = {};
              obj["business_day"] = gdata["business_day"];
              obj[gdata["business_day"]] = gdata["value"] ? true : false;
              let from_time = null;
              let to_time = null;
              gdata["subgroupData"].map((feild, feild_key) => {
                addQueue[key]["groupData"][gkey]["subgroupData"][feild_key][
                  "errors"
                ] = [];

                if (feild_key === 0) {
                  from_time = feild.value;
                  obj["business_hours_from"] = feild.value;
                }
                if (feild_key === 1) {
                  to_time = feild.value;
                  obj["business_hours_to"] = feild.value;
                }

                if (gdata["value"]) {
                  if (feild.value) {
                    if (to_time) {
                      if (
                        moment(`2/2/1990 ${to_time}`).isAfter(
                          moment(`2/2/1990 ${from_time}`)
                        )
                      ) {
                        errors.push(true);
                      }
                      if (
                        moment(`2/2/1990 ${to_time}`).isSameOrBefore(
                          moment(`2/2/1990 ${from_time}`)
                        )
                      ) {
                        errors.push(false);
                        addQueue[key]["groupData"][gkey]["subgroupData"][
                          feild_key
                        ]["errors"] = [
                          { message: `To time cannot be less than From time` },
                        ];
                      }
                    }
                    if (from_time) {
                      errors.push(true);
                    }
                  } else {
                    addQueue[key]["groupData"][gkey]["subgroupData"][feild_key][
                      "errors"
                    ] = [
                      {
                        message: `Please Select ${
                          feild_key ? "To Time" : "From Time"
                        }`,
                      },
                    ];
                    errors.push(false);
                  }
                }
              });
              if (gdata["value"] == true) {
                bhdays.push(obj);
              }
            });
            payload["working_days"] = bhdays;
            // if (bhdays && Array.isArray(bhdays) && bhdays.length == 0) {
            //   addQueue[key]["errors"].push({
            //     message: `Please Select Working Days`,
            //   });
            //   errors.push(false);
            // }
          }
        }

        if (data["mode"] === "table") {
          let series_group = [];
          if (data["rowfeilds"]) {
            data["rowfeilds"]["table_body"].map((body, body_key) => {
              let obj = {};
              body["feilds"].map((feild, feild_key) => {
                addQueue[key]["rowfeilds"]["table_body"][body_key]["feilds"][
                  feild_key
                ]["errors"] = [];
                if (
                  feild.visible &&
                  feild.element !== "text" &&
                  feild.element !== "action"
                ) {
                  if (feild.name === "queuedepartment") {
                    obj["department_id"] = feild.value;
                  }
                  if (feild.name === "service_group") {
                    obj["service_group_id"] = feild.value;
                  }
                  if (feild.name === "exclude_services") {
                    obj["exclued_services"] = feild.value;
                    payload["exclued_services"] = payload[
                      "exclued_services"
                    ].concat(feild.value ? feild.value : []);
                  }

                  if (feild.value) {
                    errors.push(true);
                  } else {
                    if (feild.name !== "exclude_services") {
                      errors.push(false);
                      let name = {};
                      name[feild.name] = false;
                      errors.push(name);
                      addQueue[key]["rowfeilds"]["table_body"][body_key][
                        "feilds"
                      ][feild_key]["errors"] = [
                        {
                          message: `Please ${feild["placeholder"]} ${feild["title"]}`,
                        },
                      ];
                    }
                  }
                }
              });
              if (Object.keys(obj).length !== 0) {
                series_group.push(obj);
              }
            });
          }
          payload[data["name"]] = series_group;
        }
      });

      addQueue.map((data, key) => {
        addQueue[key]["errors"] = [];
        if (data["mode"] === "single") {
          switch (data["name"]) {
            case "alloperator":
              payload["service_operator_id"] = data["value"];
              break;
            case "technician":
              payload["technician_id"] = data["value"];
              break;
            case "work_station":
              payload["workstation_id"] = data["value"];
              break;
            default:
              break;
          }
        }
      });
    
      const params = new URLSearchParams(this.props.location.search);
      const qid = params.get("qid");
      
      payload["queue_list_id"] = qid;
      this.setState((state) => ({
        addQueue: addQueue,
        add_queue_payload: payload,
      }));
      if (!errors.includes(false)) {
        this.setState({ isLoading: true });
        try {
          postService("updateQueueConfiguration", "POST", {
            data: payload,
          }).then((res) => {
            console.info("Work Flow", res);
            if (res.status) {
              this.setState({ isLoading: false });
              Modal.success({
                title: "Success",
                content: `${res.message}`,
                onOk: () => {
                  this.props.history.push("/queue/queue-list");
                },
              });
            } else {
              this.setState({ isLoading: false });
              Modal.error({
                title: "Error",
                content: `${res.message}`,
              });
            }
          });
        } catch (error) {
       
          this.setState((state) => ({ isLoading: false }));
          Modal.error({
            title: "Error Message",
            content: "Something is wrong. Please try again.",
          });
        }
      }
    }

    // if (addQueue) {
    //   const params = new URLSearchParams(this.props.location.search);
    //   const qid = params.get("qid");
    //   let payload = { queue_list_id: qid };
    //   let errors = [];

    //   addQueue.map((data, key) => {
    //     addQueue[key]["errors"] = [];
    //     if (data["mode"] === "single") {
    //       switch (data["name"]) {
    //         case "alloperator":
    //           payload["service_operator_id"] = data["value"];
    //           break;
    //         case "technician":
    //           payload["technician_id"] = data["value"];
    //           break;
    //         case "work_station":
    //           payload["workstation_id"] = data["value"];
    //           break;
    //         default:
    //           break;
    //       }
    //       if (data["value"]) {
    //         errors.push(true);
    //       } else if (data.name !== "technician") {
    //         addQueue[key]["errors"].push({
    //           message: `Please ${data["placeholder"]}`,
    //         });
    //         errors.push(false);
    //       }
    //     }
    //   });
    //   console.log("payload", payload);

    //   this.setState((state) => ({ addQueue: addQueue }));

    //   payload["queue_list_id"] = qid;
    //   //   validations check;
    //   if (!errors.includes(false)) {
    //     this.setState({ isLoading: true });
    //     let This = this;
    //     try {
    //       postService("updateQueueUsers", "POST", { data: payload }).then(
    //         (res) => {
    //           console.info("Work Flow", res);
    //           if (res.status) {
    //             this.setState((state) => ({ isLoading: false }));
    //             Modal.success({
    //               title: "Success",
    //               content: `${res.message}`,
    //               onOk: () => {
    //                 this.props.history.push("/queue/queue-list");
    //               },
    //             });
    //           } else {
    //             this.setState((state) => ({ isLoading: false }));
    //             Modal.error({
    //               title: "Error",
    //               content: res.message
    //                 ? res.message
    //                 : "Oops! something went wrong. Please try again.",
    //             });
    //           }
    //         }
    //       );
    //     } catch (error) {
    //       console.log(error);
    //       this.setState((state) => ({ isLoading: false }));
    //       Modal.error({
    //         title: "Error Message",
    //         content: "Something is wrong. Please try again.",
    //       });
    //     }
    //   }
    // }

    // tab2update
    // if (assignOperator) {
    //   console.log("assignOperator:", assignOperator);
    //   const params = new URLSearchParams(this.props.location.search);
    //   const qid = params.get("qid");
    //   let payload = { queue_list_id: qid };
    //   let errors = [];

    //   assignOperator.map((data, key) => {
    //     assignOperator[key]["errors"] = [];
    //     if (data["mode"] === "single") {
    //       switch (data["name"]) {
    //         case "alloperator":
    //           payload["service_operator_id"] = data["value"];
    //           break;
    //         case "technician":
    //           payload["technician_id"] = data["value"];
    //           break;
    //         case "workstation":
    //           payload["workstation_id"] = data["value"];
    //           break;
    //         default:
    //           break;
    //       }
    //       if (data["value"]) {
    //         errors.push(true);
    //       } else if (data.name !== "technician") {
    //         assignOperator[key]["errors"].push({
    //           message: `Please ${data["placeholder"]}`,
    //         });
    //         errors.push(false);
    //       }
    //     }
    //   });
    //   console.log("payload", payload);

    //   this.setState((state) => ({ assignOperator: assignOperator }));

    //   payload["queue_list_id"] = qid;
    //   //   validations check;
    //   if (!errors.includes(false)) {
    //     this.setState({ isLoading: true });
    //     let This = this;
    //     try {
    //       postService("updateQueueUsers", "POST", { data: payload }).then(
    //         (res) => {
    //           console.info("Work Flow", res);
    //           if (res.status) {
    //             this.setState((state) => ({ isLoading: false }));
    //             Modal.success({
    //               title: "Success",
    //               content: `${res.message}`,
    //               onOk: () => {
    //                 this.props.history.push("/queue/queue-list");
    //               },
    //             });
    //           } else {
    //             this.setState((state) => ({ isLoading: false }));
    //             Modal.error({
    //               title: "Error",
    //               content: res.message
    //                 ? res.message
    //                 : "Oops! something went wrong. Please try again.",
    //             });
    //           }
    //         }
    //       );
    //     } catch (error) {
    //       console.log(error);
    //       this.setState((state) => ({ isLoading: false }));
    //       Modal.error({
    //         title: "Error Message",
    //         content: "Something is wrong. Please try again.",
    //       });
    //     }
    //   }
    // }
  };

  // tab1update = () => {};
  // tab2update = () => {};

  add_more_event(eventData) {
    let { addQueue } = this.state;
    addQueue.map((data, key) => {
      if (data.name === eventData.parrent_name) {
        addQueue[key]["rowfeilds"]["table_body"] = eventData.feilds;
      }
    });

    this.setState((state) => ({ addQueue: addQueue }));
  }

  render() {
  
    let { slug } = this.props.match.params;
    let addQueue = this.state.addQueue;
    let { isLoading } = this.state;
    // let { assignOperator } = this.state;
    return (
      <div className="row pt-2 qConfigScroll addQueue">
        {console.log("addQueue", addQueue)}
        {isLoading ? <CustomLoader /> : ""}
        <div className="col-10 mx-auto">
          <div className="card px-5 pb-5 mt-3">
            <div className="steps-content">
              {/* {current === 0 && ( */}
              <QueuesListFormComponent
                {...this.props}
                {...this.state}
                onChange={this.onChange.bind(this)}
                add_more_event={this.add_more_event.bind(this)}
                Queuedata={addQueue}
              />
              {/* )} */}
              {/* {current === 1 && ( */}
              {/* <QueuesListFormComponent
                {...this.props}
                {...this.state}
                onChange={this.onChange.bind(this)}
                Queuedata={assignOperator}
              /> */}
              {/* )} */}
            </div>
            <div className="steps-action pt-2 text-center">
              {slug === "add" && (
                <React.Fragment>
                  {/* {current < steps.length - 1 && (
                    <button
                      type="button"
                      className="btn btn-dark"
                      onClick={() => this.tab1sumbit()}
                    >
                      Next
                    </button>
                  )} */}
                  {/* {current === steps.length - 1 && ( */}
                  <button
                    type="button"
                    className="btn btn-magenta"
                    onClick={() => this.onSubmit()}
                  >
                    Submit
                  </button>
                  {/* )} */}
                </React.Fragment>
              )}
              {slug === "edit" && (
                <React.Fragment>
                  {/* {current < steps.length - 1 && ( */}
                  <React.Fragment>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => this.onUpdate()}
                    >
                      Update
                    </button>
                    <button
                      type="button"
                      className="btn btn-light ml-3"
                      onClick={() =>
                        this.props.history.push("/queue/queue-list")
                      }
                    >
                      Close
                    </button>
                    {/* <button
                        type="button"
                        className="btn btn-magenta ml-3"
                        onClick={() => this.next(current + 1)}
                      >
                        Next
                      </button> */}
                  </React.Fragment>
                  {/* )} */}
                  {/* {current === steps.length - 1 && ( */}
                  {/* <React.Fragment>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => this.tab2update()}
                    >
                      Update
                    </button>
                    <button
                      type="button"
                      className="btn btn-light ml-3"
                      onClick={() =>
                        this.props.history.push("/queue/queue-list")
                      }
                    >
                      Close
                    </button>
                  </React.Fragment> */}
                  {/* )} */}
                </React.Fragment>
              )}
              {slug === "view" && (
                <React.Fragment>
                  {/* {current < steps.length - 1 && (
                    <button
                      type="button"
                      className="btn btn-magenta"
                      onClick={() => this.next(current + 1)}
                    >
                      Next
                    </button>
                  )} */}
                  {/* {current === steps.length - 1 && ( */}
                  <button
                    type="button"
                    className="btn btn-danger ml-3"
                    onClick={() => this.props.history.push("/queue/queue-list")}
                  >
                    Close
                  </button>
                  {/* )} */}
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Queueadd;
